<div class="ni-home ni-home-search-app">
  <app-search-primary-navigation [searchResult]="searchResult"></app-search-primary-navigation>
  <app-search-secondary-navigation [searchResult]="searchResult"></app-search-secondary-navigation>
  <app-search-utility-bar [searchResult]="searchResult" [searchParams]="searchParams"></app-search-utility-bar>
  <app-search-filter-box [searchResult]="searchResult"></app-search-filter-box>
  <app-search-message-box *ngIf="!searchResult?.highlightedEntity" [searchResult]="searchResult"></app-search-message-box>
  <app-search-dym [searchResult]="searchResult"></app-search-dym>
  <app-search-result-info [searchResult]="searchResult"></app-search-result-info>

  <app-search-results [searchResult]="searchResult" [searchParams]="searchParams"></app-search-results>

  <ng-container *ngIf="searchResult">
    <app-search-pagination [searchResult]="searchResult" [searchParams]="searchParams"></app-search-pagination>
  </ng-container>
</div>
